module.exports = __webpack_public_path__ + "img/kleisma2m-m@1.0f74155c.jpg";